module.exports = __webpack_public_path__ + "assets/img_the-market.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_the-market.jpg
 ** module id = 135
 ** module chunks = 1
 **/